import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionCreateInput } from '../generated/globalTypes';
import { createQuestionMutation, createQuestionMutationVariables } from '../generated/createQuestionMutation';
import { questionFieldsFragment } from '../models/Question';

/**
 * Get a callback to create a Question in the store.
 */
export function useCreateQuestionCallback(): [(model: QuestionCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionMutation, createQuestionMutationVariables>(
        gql`
            mutation createQuestionMutation ($model: QuestionCreateInput!) {
                createQuestion(model: $model) {
                    ...questionFields
                }
            }

            ${questionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
